import $ from 'jquery';
window.flash = (message, status = 'success') => {
    const $element = $('<div></div>')
        .text(message)
        .attr('data-notification-status', status)
        .addClass('bar-top notify')
        .addClass('do-show')
        .appendTo($('#flash-message').empty());
    hide();
};

const hide = () => {
    const $element = $('.notify.do-show');
    setTimeout(() => {
        $element.fadeOut('slow').queue(function () {
            $element.removeClass('do-show');
        })
    }, 1200);
};

// Enhanced flash message system for admin forms
window.FlashMessage = {
    show: (type, message) => {
        // Map Bootstrap alert types to notification status
        const statusMap = {
            'success': 'success',
            'danger': 'error',
            'warning': 'warning',
            'info': 'notice'
        };
        
        const status = statusMap[type] || 'notice';
        
        // Use existing flash function if available
        if (window.flash) {
            window.flash(message, status);
        } else {
            // Fallback implementation
            const $flashContainer = $('#flash-message');
            if ($flashContainer.length > 0) {
                const $element = $('<div></div>')
                    .text(message)
                    .attr('data-notification-status', status)
                    .addClass('bar-top notify do-show')
                    .appendTo($flashContainer.empty());
                
                setTimeout(() => {
                    $element.fadeOut('slow').queue(function () {
                        $element.removeClass('do-show');
                        $element.remove();
                    });
                }, 3000);
            }
        }
    }
};

$(() => {
    hide();
});